import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';
export const SortField = iotsUtils.fromList(constants.wholeHouse.usage.sortFields);
